import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    CircularProgress
} from '@mui/material';

const DeleteConfirmDialog = ({ open, onClose, radiologist, onConfirm, loading }) => {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{t('radiologists.deleteConfirmTitle') || 'Delete Radiologist'}</DialogTitle>
            <DialogContent>
                <Typography>
                    {t('radiologists.deleteConfirmMessage') || 'Are you sure you want to delete this radiologist?'}
                    {radiologist && (
                        <Typography component="span" fontWeight="bold">
                            {' '}{radiologist.name}?
                        </Typography>
                    )}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    {t('common.cancel') || 'Cancel'}
                </Button>
                <Button
                    color="error"
                    onClick={onConfirm}
                    disabled={loading}
                >
                    {loading ? <CircularProgress size={20} /> : (t('common.delete') || 'Delete')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmDialog;